import React, { createContext, useContext, useState, ReactNode } from 'react';
import { AppContextType } from '../Types/UnitFeatureTypes';

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

  const [loading, setLoading] = useState<boolean>(false);
  const [snackbar, setSnackbar] = useState<AppContextType["snackbar"]>({
      open: false,
      message: '',
      severity: 'success',
      timer: 6000,
  });      
  const [warningDialog, setWarningDialog] = useState<AppContextType["warningDialog"]>({
      open: false,
      message: '',
      title: '',
      onConfirm: () => {},
      onCancel: () => {},
  });

  
  const setSnackbarFunc = (open: boolean, message: string, severity: 'success' | 'error' | 'warning' | 'info') => {
    setSnackbar({ open: open, message, severity });
  };

  const setWarningDialogFunc = (open: boolean, message: string, title: string, onConfirm: () => void, onCancel: () => void) => {
    setWarningDialog({ open, message, title, onConfirm, onCancel });
  };

  const contextValue: AppContextType = {
    loading,
    setLoading,
    snackbar,
    setSnackbar: setSnackbarFunc,
    warningDialog,
    setWarningDialog: setWarningDialogFunc,
    setDialog: () => {},
  };
  
  return (
    <AppContext.Provider value={contextValue}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = (): AppContextType => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useApp must be used within an AppContextProvider');
  }
  return context;
};
